import { Injectable } from '@angular/core';
import { IAsset } from '@shared/interfaces/asset.interface';
import { IFilter } from '@shared/interfaces/filter.interface';
import { Filter } from '@shared/models/filter.model';
import { IssuesService } from '@shared/services/issues.service';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationService } from '@shared/services/pagination/pagination.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationIssuesService extends PaginationService<IAsset> {
  private static readonly DEFAULT_IS_DELETED_FILTER: IFilter = {
    label: 'COMMON.ACTIVE',
    key: 'isDeleted',
    value: 'false'
  };

  private static readonly DEFAULT_STATUS_FILTER: IFilter = {
    label: 'FILTERS.STATUS',
    key: 'status',
    value: null
  };

  private static readonly DEFAULT_PARENT_LOCATION_FILTER: IFilter = {
    key: 'parentLocation',
    value: null
  };

  private static readonly DEFAULT_SUB_LOCATION_FILTER: IFilter = {
    key: 'subLocation',
    value: null
  };
  private static readonly DEFAULT_IS_FROM_ASSET: IFilter = {
    key: 'asset',
    value: null
  };
  private static readonly DEFAULT_START_DATE: IFilter = {
    key: 'startDate',
    value: null
  };
  private static readonly DEFAULT_END_DATE: IFilter = {
    key: 'endDate',
    value: null
  };

  private _filtersScope: any;

  constructor(_paginable: IssuesService, _logger: LoggerService) {
    super(_paginable, _logger);

    this.setFilters([
      PaginationIssuesService.DEFAULT_IS_DELETED_FILTER,
      PaginationIssuesService.DEFAULT_PARENT_LOCATION_FILTER,
      PaginationIssuesService.DEFAULT_SUB_LOCATION_FILTER,
      PaginationIssuesService.DEFAULT_IS_FROM_ASSET,
      PaginationIssuesService.DEFAULT_START_DATE,
      PaginationIssuesService.DEFAULT_END_DATE,
      PaginationIssuesService.DEFAULT_STATUS_FILTER
    ]);
  }

  public getFilters(): IFilter[] {
    return this._filtersScope;
  }

  public reset() {
    super.reset();

    this.setFilters([
      PaginationIssuesService.DEFAULT_IS_DELETED_FILTER,
      PaginationIssuesService.DEFAULT_PARENT_LOCATION_FILTER,
      PaginationIssuesService.DEFAULT_SUB_LOCATION_FILTER,
      PaginationIssuesService.DEFAULT_IS_FROM_ASSET,
      PaginationIssuesService.DEFAULT_START_DATE,
      PaginationIssuesService.DEFAULT_END_DATE,
      PaginationIssuesService.DEFAULT_STATUS_FILTER
      
    ]);
  }

  public setFilters(filters: Partial<IFilter>[]): void {
    this._filtersScope = filters.map((f) => new Filter(f));
    super.setFilters(this._filtersScope);
  }
}
